import { IDateTimeOptions } from '../models/date-time-format-options.model';

function getFormatOption(
  format: IDateTimeOptions | undefined,
  timezone: string
): Intl.DateTimeFormatOptions {
  // Define format options
  const formatOptions: Record<string, Intl.DateTimeFormatOptions> = {
    short: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      timeZone: timezone
    },
    medium: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      timeZone: timezone
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: timezone
    },
    full: {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: timezone
    },
    shortTime: {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
      timeZone: timezone
    },
    shortTimeWithTZ: {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
      timeZone: timezone,
      timeZoneName: 'short'
    },
    mediumTime: {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: true,
      timeZone: timezone
    },
    shortDateTime: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
      timeZone: timezone
    },
    mediumDateTime: {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
      timeZone: timezone,
      timeZoneName: 'short'
    },
    longDateTime: {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
      timeZone: timezone,
      timeZoneName: 'short'
    },
    weekday: {
      weekday: 'short',
    }
  };

  return format
    ? formatOptions[format]
    : formatOptions['medium'];
}

export function formatDateWithOptions(
  dateObj: Date,
  format?: IDateTimeOptions,
  locale?: string,
  timezone?: string,
  customFormat?: Intl.DateTimeFormatOptions | undefined
): string {
  // Intl.DateTimeFormat with timeZone option handles timezone conversion automatically
  const intlOptions = customFormat || getFormatOption(format, timezone || '');

  return new Intl.DateTimeFormat(locale, intlOptions).format(dateObj);
}
